import React from 'react'

import { RouterProvider } from 'react-router-dom'

import router from '@/routes/router'

import { usePushNotifications } from './hooks/usePushNotifications'

const App: React.FC = () => {
  usePushNotifications()

  return <RouterProvider router={router} />
}

export default App
